import React from 'react'
import { FilterName, FacetName } from '../../__generated__/fed-graphql-types'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { SimpleCheckbox } from '../../components/search-filters-simple-checkbox/simple-checkbox'
import { IconWarranty } from '@at/design-system-icons'

export const ManufacturerApproved = withFacetContext(
    FacetName.is_manufacturer_approved,
    withFilterContext(FilterName.is_manufacturer_approved, SimpleCheckbox, {
        title: 'Manufacturer approved',
        hideOnDisabled: false,
        icon: <IconWarranty title={'Manufacturer approved icon'} customSize={{ height: 18, width: 18 }} />,
    })
)
